// extracted by mini-css-extract-plugin
export default {"root":"Livp1u","price":"mP4Nmy","aMonth":"hfCetp"};